import React from "react"
// import { GravityForm } from "react-gravity-forms"
// import { navigate } from "gatsby"
// import forms from "../../../../wordsby/data/gravity_forms.json"

// import app components
import Edges from "../../_layout/edges"

const Form = ({ form_id }) => {
  return (
    <Edges size="sm">
      {/* <GravityForm
        forms={forms}
        id={form_id}
        url="https://wordsby.barework.com"
        onRedirect={path => navigate(path)}
      /> */}
    </Edges>
  )
}

export default Form
